module.exports = __webpack_public_path__ + "7776bd32fb9732ad0643d18eb693d6ec.svg";